import React from 'react';
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import SignatureCanvas from "react-signature-canvas";
import ObjectOverride from "../ObjectOverride";
import {Types} from "../index";
import moment from "moment/moment";

export default class LocationArchive extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations._name);
	}

	setSigPadWidth = () => {
		let scrollbarWidth = 17; //Based on Google Chrome, can detect different browsers if necessary
		let viewportWidth = window.innerWidth - scrollbarWidth;
		const styledPaddingAndPositioning = ((15 + 14 + 40) * 2)

		let breakpointXsmSmCalc = () => viewportWidth - styledPaddingAndPositioning;
		let breakpointMdCalc = () => viewportWidth * 0.65 - styledPaddingAndPositioning;
		let breakpointLgXlgCalc = () => (viewportWidth * 0.65 - 15 * 2 - 14 * 2) * 0.7 - 40 * 2;
		let first = window.innerWidth < 769 ? breakpointXsmSmCalc()
			: window.innerWidth < 992 ? breakpointMdCalc()
				: breakpointLgXlgCalc();
		if (this.state.sigWidth !== first || !this.state.sigWidth) {
			return first;
		}
		return 100;
	}

	// noinspection JSUnusedLocalSymbols
	handleProcess(event, requestOverride) {
		this.state.archive_signature = this.sigPad.getCanvas().toDataURL('image/png');
		this.state.archive_signature_date = moment().local().format('YYYY-MM-DD HH:mm:ss');
		return true;
	}

	handleSubmit = async () => {
		if(this.sigPad.isEmpty()){
			this.setState({invalidSignature: true})
			return;
		}
		this.handleProcess(null, null);
		this.model.pkey = this.state._id;
		await this.model.submit(this, 'POST_LOCATION_ARCHIVED');
		this.props.history.push('/locations');
	}

	render() {
		return (
			<div>
				<CardContent>
					<Typography variant="h3" gutterBottom>Sign to authorize deletion of data from this location: {this.state.name}</Typography>
					<Typography variant="body1" gutterBottom>
						I certify I have backed up and retained all required data stored on this rented server in compliance with ATF Rulings 2016-1,
						2016-2, 2016-3, 2021R-05F and 2022-01. Continuing will archive and delete {this.state.name} and prevent it from being used
						again in the future. <b>There is no way to undo this without contacting support. There will be a <span style={{color: "#FF0000"}}>
						$200 fee</span> to restore an archived location from a backup.</b>
					</Typography>
				</CardContent>
				{this.state.invalidSignature &&
					<div className={'row'}>
						<div className={'col errorColor pl-3'} style={{marginTop: '-10px', marginBottom: '10px'}}>
							<em>Signature is required</em>
						</div>
					</div>
				}
				<CardContent style={{display: 'flex', width: '100%'}}>
					<span className={'signature'}/>
					<div style={{backgroundColor: '#f2f3f4'}}>
						<SignatureCanvas penColor='black' minWidth={3}
						                 canvasProps={{width: this.setSigPadWidth(), height: 300, className: 'sigCanvas'}}
						                 ref={ref => this.sigPad = ref}/>
					</div>
				</CardContent>
			</div>
		);
	}
}
